export default "__VITE_ASSET__DFyNxFsY__"